import * as types from './mutation-types'

export default {
    [types.LOAD_DAYS](state, data) {
        state.days = data.data
    },
}
